import { cn } from '../../utils/cn';

/**
 * The cue a folder card shows while a dragged deck/folder hovers it AND would
 * move in (`lifted`): the card grows toward the carried item — and only that;
 * the preview lift/fan stays a hover/press thing. Whatever holds the grid must not
 * clip it (web's `CollapsibleContent` only clips while closed or moving).
 *
 * WEB-ONLY as classes: they sit on the card's root Pressable, where a native
 * `transition-*` upgrades the host to Reanimated (the crash in
 * `Pressable.native.tsx`) and a `scale-*` flipped in place is the runtime-class
 * toggle trap. Native grows through {@link folderDropCueNativeStyle} instead.
 */
export const folderDropCueClass = (lifted: boolean, view: 'grid' | 'list') =>
  cn(
    'web:transition-transform web:duration-200 web:ease-out',
    lifted
      ? view === 'list'
        ? 'web:scale-[1.02]'
        : 'web:scale-[1.04]'
      : 'web:scale-100',
  );

// Module constants: RN diffs `style` by reference.
const NATIVE_GROW = {
  grid: { transform: [{ scale: 1.04 }] },
  list: { transform: [{ scale: 1.02 }] },
} as const;

/** Native's drop cue: the same grow as a plain inline style (it snaps, no easing). */
export const folderDropCueNativeStyle = (lifted: boolean, view: 'grid' | 'list') =>
  lifted ? NATIVE_GROW[view] : undefined;
